/* eslint-disable no-useless-escape */
/*
 * @Author: jerryfwang
 * @Date: 2019-09-10 17:42:14
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-12-18 10:46:29
 */
import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import './header.scss';
type Props = {
  value: Object,
};
const pointReg = (str, reg) => str.replace(/[\:|\uFF1A]/g, '').replace(reg, ''); // 去掉冒号
export default class Rumor extends React.Component<Props> {
  el: null;
  constructor(props) {
    super(props);
    this.state = {
      isExpend: false,
      isShow: false,
    };
  }
  @autobind
  expendFnc() {
    this.setState({
      isExpend: !this.state.isExpend,
    });
  }
  componentDidMount() {
    if (this.el) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        isOmit: this.el.scrollHeight > this.el.offsetHeight, // 是否是折屏
      });
    }
  }
  render() {
    const { value } = this.props;
    if (!value) {
      return null;
    }
    const { title, researcher: { author, desc, time, img: imgUrl } = {}, keyPoints = [] } = value || {}; // researcher, keyPoints
    const points = keyPoints.filter((item) => pointReg(item).indexOf('查证要点') < 0);
    const { isExpend, isOmit } = this.state;
    const s1 = `title_content ${isExpend ? '' : 'content_expend'} ${!isExpend && isOmit ? 'ellipsis' : ''}`;
    const s2 = `title_icon ${isExpend ? '' : 'title_expend'}`;
    return (
      <div className="news_rumor_content">
        <div style={{ position: 'relative' }}>
          <div
            className={s1}
            ref={(node) => {
              this.el = node;
            }}
          >
            {title}
          </div>
          {isOmit ? (
            <div className="title_click_view" onClick={this.expendFnc}>
              <div className={s2}></div>
            </div>
          ) : null}
        </div>
        {author ? (
          <div className="author_content">
            <div className="header_view">
              <img className="header" src={imgUrl} />
              <div className="icon" />
            </div>
            <div className="author_view">
              <div className="authorName">
                <div className="title">{author}</div>
                <div className="icon">查证者</div>
              </div>
              <div className="desc_view">
                <div>
                  {pointReg(time, '时间')} | {desc}
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <div className="points_content">
          {points.map((element, index) => (
            <div className="points" key={index}>
              <div className="mark"></div>
              {element}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
